/* esm.sh - react-dom@19.2.6/client */
export * from "/*react-dom@19.2.6/esnext/client.mjs";
export { default } from "/*react-dom@19.2.6/esnext/client.mjs";
